import { render, staticRenderFns } from "./ReportModalCreate.vue?vue&type=template&id=3b1bec12&"
import script from "./ReportModalCreate.vue?vue&type=script&lang=js&"
export * from "./ReportModalCreate.vue?vue&type=script&lang=js&"
import style0 from "./ReportModalCreate.vue?vue&type=style&index=0&id=3b1bec12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports